export default __webpack_public_path__ + "media/brand3x.044c7592.png";